
export function is_weixin(){
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1
}
 //微信消息fengkuang参数
 export function getQueryWechat(data:any,name:any){
  var a = data;
  if(a.indexOf(name)==-1)return false;
  var arr = a.split(name);
  return arr;
}